import { LyneButton } from "components/Lyne/LyneButton";
import { getResourceStrict, ResourceKey, ResourceKeys } from "providers";
import React from "react";

interface EditFormFooterProps {
  isSubmitting: boolean;
  isDirty: boolean;
  submitText?: ResourceKey;
  cancelText?: ResourceKey;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const EditFormFooter: React.FC<EditFormFooterProps> = ({
  isSubmitting,
  isDirty,
  submitText,
  cancelText,
  onSubmit,
  onCancel,
}) => {
  const submitLabel = getResourceStrict(submitText ?? ResourceKeys.Actions_Save);
  const cancelLabel = getResourceStrict(cancelText ?? ResourceKeys.Actions_Cancel);

  return (
    <div className="mb-4">
      <LyneButton onClick={onSubmit} className="mr-2" disabled={isSubmitting || !isDirty} value={submitLabel} />
      <LyneButton onClick={onCancel} value={cancelLabel} disabled={isSubmitting} kind="secondary" />
    </div>
  );
};
